module.exports = __webpack_public_path__ + "67bc964ce0dc59a37a0b9184eb93ec36.pdf";